var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.GET_MOUNTED_COURSE.mounted_curses)?_c('div',{staticClass:"modules"},_vm._l((_vm.GET_MOUNTED_COURSE.mounted_curses.modules),function(data){return _c('div',{key:data.id},[_c('ModulesBox',{attrs:{"item":data}})],1)}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }